module.exports = __webpack_public_path__ + "media/images/logo_pl-9f22ba05fca93642af71e0b12329bb0a.svg";